import api from '../api/aigc-api'

export default {
  generateWork (params) {
    return new Promise((resolve, reject) => {
      api.generateWork(params).then(({ data }) => {
        if (data.code === 200) {
          resolve(data.result || {})
        } else {
          reject(data)
        }
      })
    })
  },
  generateWorkJson (params) {
    return new Promise((resolve, reject) => {
      api.generateWorkJson(params).then(({ data }) => {
        if (data.code === 200) {
          resolve(data.result || {})
        } else {
          reject(data)
        }
      })
    })
  }
}
